import React, { useEffect, useState } from "react";
import { createAddressEvent, formatBookingJson, getFormDataForStorage, manualGoogleEvents } from '../helpers/helpers'
import { GooglePlaceAutocomplete, SelectInput } from '@hometown/react-hometown-lib';
import CircularProgress from '@mui/material/CircularProgress';

const options = [
    {
      "value": "1",
      "label": "Trash"
    },
    {
      "value": "2",
      "label": "Construction Debris"
    },
    {
      "value": "3",
      "label": "Concrete"
    },
    {
      "value": "4",
      "label": "Roofing"
    },
    {
      "value": "5",
      "label": "Yard Waste"
    },
    {
      "value": "6",
      "label": "Dirt"
    },
    {
      "value": "7",
      "label": "Rock or Brick"
    }
]

const ViewDumpsterPricesForm = ({ state, btnLabel, onSubmit, id }) => {
    const dataFromStorage = getFormDataForStorage(); 
    let addressData = dataFromStorage?.addressData ? { ...dataFromStorage.addressData } : {};
    let defaultWasteType = dataFromStorage?.wasteType || '';
    const [googlePlace, setGooglePlace] = useState('');
    const [isError, setIsError] = useState(false);
    const [selectedWasteType, setSelectedWasteType] = useState(defaultWasteType);
    const [formValues, setFormValues] = useState(addressData ? { ...addressData } : {});
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
      const element = document.getElementById("waste-type-select");
      if (!element) return;

      if (selectedWasteType) {
        element.classList.add("select-shrink");
      } else {
        element.classList.remove("select-shrink");
      }
    }, [selectedWasteType]);

    const handleSubmit = async () => {
      try {
        setIsSubmitting(true);
        if(!selectedWasteType){
          return setIsError(true)
        } else {
          setIsError(false)
        }
  
        if(!formValues.odf_postal_code) return
        const formattedValues = formatBookingJson({ ...formValues, wasteType: selectedWasteType });
        if(onSubmit) {
          await onSubmit(formattedValues);
        } else {
          manualGoogleEvents('manualFormSubmition');
          window.location.href = '/book';
        }
      } catch (error) {
        console.log('error', error)
      } finally {
        setIsSubmitting(false);
      }
    }

    const handleWasteChange = (wasteType) => {
      if(wasteType){
        setIsError(false);
        setSelectedWasteType(wasteType)
      } else {
        setIsError(true)
      }
    }

    const handleAddressChange = (place) => {
      setGooglePlace(JSON.stringify(place))
      let addressValues = {}
      place.map((value) => {
          addressValues["odf_" + value[0]] = value[1]
      })
      createAddressEvent({
        street1: addressValues.odf_street,
        street2: addressValues.odf_street2,
        city: addressValues.odf_locality,
        zipCode: addressValues.odf_postal_code,
        state: addressValues.odf_state
      })
      setFormValues({ ...addressValues })
    }

    return (
        <div className="prices-form">
          {state &&
            <div class="prices-title">
                <h3>View dumpsters for rent in {state}</h3>
            </div>
            }
            <div id="waste-type-select" className="select-ondeff outlined-select">
              <SelectInput
                  id={id}
                  className="outlined-select" 
                  value={selectedWasteType}
                  name="wasteType"
                  label="Select your waste"
                  data={options}
                  onChange={handleWasteChange}
                  error="Please select an option"
                  isError={isError}
                  fullWidth
              />
            </div>
            <div className="address-ondeff">
              <GooglePlaceAutocomplete
                  id='view-prices-address'
                  name='address'
                  label="Enter delivery address"
                  fieldName="address"
                  placeholder=""
                  apiKey={`${process.env.GATSBY_BOOKABLE_API_AUTOCOMPLETE}`}
                  className="fill-available"
                  resetError = {()=>{}}
                  onResetField = {()=>{setGooglePlace('')}}
                  onChange = {(place) => handleAddressChange(place)}
                  onChangeValue={googlePlace}
                  formValues={formValues}
                  fullWidth
                  alwaysShrink={!!formValues?.odf_postal_code}
                  // showSearchIcon
              />
            </div>
            <div className="button-wrapper">
              <button class='view-dumpster-prices' onClick={handleSubmit}>{isSubmitting ? <CircularProgress style={{ color: '#FFF' }} /> : btnLabel}</button>
            </div>
        </div>
    )
}

export default ViewDumpsterPricesForm;
